import { defineStore } from 'pinia'
import type { Notebook } from '@prisma/client'
import type { Ref } from 'vue'

export declare interface DocumentStore {
  documents: Ref<Notebook[]>
  setDocuments(documents?: Notebook[]): void
}

export const useDocument = defineStore('document', (): DocumentStore => {
  const documents: Ref<Notebook[]> = ref([])

  function setDocuments(_documents?: Notebook[]): void {
    documents.value = _documents || []
  }

  return {
    documents,
    setDocuments
  }
})
